import { Injectable } from '@angular/core';
import { AuthStore } from '../../../../app/@store';
import { BaseApiPickerImpl } from '../base.api-picker';
import { MonetizationMockApi } from './monetization.mock.api';
import { MonetizationApi } from './monetization.api';

@Injectable({ providedIn: 'root' })
export class MonetizationApiPicker extends BaseApiPickerImpl<
  MonetizationApi | MonetizationMockApi
> {
  constructor(
    protected authStore: AuthStore,
    protected realApi: MonetizationApi,
    protected mockApi: MonetizationMockApi
  ) {
    super(authStore, realApi, mockApi);
  }
}
